import { StyledAlert } from "App/global-style";
import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { useTexts } from "Components/TextContext";
import { formatToDDMMYYYY } from "Formatting/formatDate";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { CloseToMaxAgeWarning } from "./CloseToMaxAgeWarning";
import { AkaChildProductDetailsFormValues } from "./akaChildProductDetailsInterfaces";

interface Props {
  formProps: FormikProps<AkaChildProductDetailsFormValues>;
  childError: string;
  setCurrentDate: (value: string) => void;
}

export const AkaChildProductDetailsFormElements = ({
  formProps,
  childError,
  setCurrentDate,
}: Props): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <>
      <Input
        large
        id="childFirstName"
        name="childFirstName"
        label={getText("akachildform.label.childfirstname")}
        error={getError("childFirstName", formProps)}
        inputProps={{ maxLength: 25 }}
        inputMode={InputMode.TEXT}
      />
      <Input
        large
        id="childBirthDate"
        name="childBirthDate"
        label={getText("akachildform.label.childbirthdate")}
        error={childError ? "" : getError("childBirthDate", formProps)}
        onChange={(e) => {
          e.target.value = formatToDDMMYYYY(e.target.value);
        }}
        inputProps={{
          maxLength: 10,
          autoComplete: "off",
          onBlur: () => {
            setCurrentDate(
              formProps.values.childBirthDate
                ? formProps.values.childBirthDate
                : "",
            );
          },
        }}
        inputMode={InputMode.NUMERIC}
      />
      <CloseToMaxAgeWarning />
      {/*  TODO: link til spedbarnsforsikring */}
      {childError && (
        <StyledAlert
          alertId="childError"
          title={getText("akachildform.alerttitle.childbirthdate")}
          description={childError}
          fluid
        />
      )}
    </>
  );
};
